import React from "react"
import colors from "@constants/colors"
import { IconWrapper } from "./utils"

// TODO: Move Icons to Chakra UI theme
interface IconProps extends React.SVGProps<any> {
  w?: string
  h?: string
  strokeColor?: string
  strokeWidth?: string
  opacity?: string
}

export const Menu: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  strokeWidth = "1.5",
  ...rest
}: IconProps) => (
  <svg
    width="30"
    height="30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M5 9h16.923M5 15h20M5 21h13.846" stroke="#000" strokeWidth="1.5" />
  </svg>
)

export const Checkmark: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  ...rest
}) => (
  <svg
    width={rest.width || "100%"}
    height={rest.height || "100%"}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.256 10l3.162 3.162 6.325-6.324"
      stroke={rest.stroke || strokeColor}
    />
  </svg>
)

export const ShoppingCart: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  strokeWidth = "2.5",
  ...rest
}) => (
  <svg
    width="34"
    height="31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.93 6.432h2.28a1 1 0 01.975.777l3.01 13.148a1 1 0 00.976.777h13.402"
      stroke="#000"
      strokeWidth="1.5"
    />
    <path
      d="M6.875 11.116h16.969a1 1 0 01.975 1.222l-.915 4.016a1 1 0 01-.975.778H8.482"
      stroke="#000"
      strokeWidth="1.5"
    />
    <circle cx="9.414" cy="24.781" fill="#000" r="1.318" />
    <circle cx="22.02" cy="24.781" fill="#000" r="1.318" />
    {/* Todo link cart price to svg*/}
    {/* <circle cx="27.016" cy="6.5" r="6.5" fill="#C8102E" />
    <path
      d="M26.817 5.01l-.93.861-.49-.581 1.498-1.246h.762V9h-.84V5.01z"
      fill="#F9F9F9"
    /> */}
  </svg>
)

export const MapPin: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  ...rest
}) => (
  <svg
    width="20"
    height="30"
    viewBox="0 0 38 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38 18.0341C38 32.0606 19 44.0833 19 44.0833C19 44.0833 0 32.0606 0 18.0341C7.50886e-08 13.2512 2.00178 8.66411 5.56497 5.28206C9.12816 1.90001 13.9609 0 19 0C24.0391 0 28.8718 1.90001 32.435 5.28206C35.9982 8.66411 38 13.2512 38 18.0341Z"
      fill="white"
    />
    <path
      d="M38 18.8182C38 33.4545 19 46 19 46C19 46 0 33.4545 0 18.8182C7.50886e-08 13.8273 2.00178 9.04081 5.56497 5.51172C9.12816 1.98262 13.9609 0 19 0C24.0391 0 28.8718 1.98262 32.435 5.51172C35.9982 9.04081 38 13.8273 38 18.8182Z"
      fill={strokeColor}
    />
    <path
      d="M19.0001 25.0914C22.4979 25.0914 25.3334 22.283 25.3334 18.8186C25.3334 15.3543 22.4979 12.5459 19.0001 12.5459C15.5023 12.5459 12.6667 15.3543 12.6667 18.8186C12.6667 22.283 15.5023 25.0914 19.0001 25.0914Z"
      fill="white"
    />
  </svg>
)

export const Facebook: React.FC<IconProps> = ({
  strokeColor = colors.white,
  ...rest
}) => (
  <svg
    width="25"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>Facebook Icon</title>
    <path
      d="M12.752 1.838c-5.55 0-10.049 4.518-10.049 10.091 0 4.998 3.623 9.138 8.373 9.94v-7.835H8.652v-2.819h2.424V9.136c0-2.412 1.467-3.726 3.61-3.726 1.026 0 1.908.077 2.164.11v2.522h-1.486c-1.165 0-1.39.556-1.39 1.372v1.8h2.78l-.362 2.819h-2.418v7.903c4.972-.608 8.827-4.853 8.827-10.01 0-5.57-4.5-10.088-10.049-10.088z"
      fill={rest.fill || strokeColor}
    />
  </svg>
)

export const Instagram: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
    {...rest}
  >
    <title>Instagram Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.072 4c-2.193 0-2.467.01-3.328.049-.86.039-1.446.175-1.96.375-.53.206-.98.482-1.43.93a3.957 3.957 0 0 0-.93 1.43c-.2.514-.336 1.1-.375 1.96-.04.86-.049 1.135-.049 3.328 0 2.192.01 2.467.049 3.328.039.859.175 1.445.375 1.959.206.53.482.98.93 1.43.45.448.9.724 1.43.93.514.2 1.1.336 1.96.376.86.039 1.135.048 3.328.048 2.192 0 2.467-.01 3.328-.048.859-.04 1.445-.176 1.959-.376.53-.206.98-.482 1.43-.93.448-.45.724-.9.93-1.43.2-.514.336-1.1.376-1.96.039-.86.048-1.135.048-3.327 0-2.193-.01-2.467-.048-3.328-.04-.86-.176-1.446-.376-1.96a3.958 3.958 0 0 0-.93-1.43 3.956 3.956 0 0 0-1.43-.93c-.514-.2-1.1-.336-1.96-.375-.86-.04-1.135-.049-3.327-.049zm0 1.454c2.155 0 2.41.009 3.261.047.787.036 1.214.168 1.499.278a2.5 2.5 0 0 1 .928.604 2.5 2.5 0 0 1 .604.928c.11.285.242.712.278 1.499.039.851.047 1.106.047 3.262 0 2.155-.008 2.41-.047 3.261-.036.787-.168 1.214-.278 1.499a2.5 2.5 0 0 1-.604.928 2.5 2.5 0 0 1-.928.604c-.285.11-.712.242-1.499.278-.85.039-1.106.047-3.261.047-2.156 0-2.411-.008-3.262-.047-.787-.036-1.214-.168-1.499-.278a2.5 2.5 0 0 1-.928-.604 2.5 2.5 0 0 1-.604-.928c-.11-.285-.242-.712-.278-1.499-.038-.85-.047-1.106-.047-3.261 0-2.156.009-2.41.047-3.262.036-.787.168-1.214.278-1.499a2.5 2.5 0 0 1 .604-.928 2.5 2.5 0 0 1 .928-.604c.285-.11.712-.242 1.499-.278.851-.038 1.106-.047 3.262-.047z"
      fill={rest.fill || strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.07 14.761a2.69 2.69 0 1 1 0-5.38 2.69 2.69 0 0 1 0 5.38zm0-6.835a4.145 4.145 0 1 0 0 8.29 4.145 4.145 0 0 0 0-8.29zM17.347 7.764a.969.969 0 1 1-1.937 0 .969.969 0 0 1 1.937 0"
      fill={rest.fill || strokeColor}
    />
  </svg>
)

export const Twitter: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
    {...rest}
  >
    <title>Twitter Icon</title>
    <path
      d="M21 6.846a7.555 7.555 0 0 1-2.128.57 3.644 3.644 0 0 0 1.63-2 7.537 7.537 0 0 1-2.355.877 3.747 3.747 0 0 0-2.706-1.142c-2.048 0-3.708 1.619-3.708 3.615 0 .283.033.56.096.824a10.617 10.617 0 0 1-7.641-3.777 3.528 3.528 0 0 0-.502 1.817 3.59 3.59 0 0 0 1.65 3.009 3.762 3.762 0 0 1-1.68-.452v.045c0 1.752 1.278 3.213 2.974 3.545a3.804 3.804 0 0 1-1.675.062c.472 1.436 1.841 2.481 3.464 2.51a7.56 7.56 0 0 1-4.605 1.548c-.3 0-.594-.017-.884-.05a10.689 10.689 0 0 0 5.683 1.623c6.82 0 10.549-5.508 10.549-10.285 0-.157-.004-.312-.011-.468A7.426 7.426 0 0 0 21 6.847z"
      fill={rest.fill || strokeColor}
    />
  </svg>
)

export const Expand: React.FC<IconProps & { strokeWeight?: string }> = ({
  strokeColor = "#63666A",
  strokeWeight = "5",
  ...rest
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.5996 5.3999L20.4197 15.5797"
      stroke={strokeColor}
      strokeWidth={strokeWeight}
    />
    <path
      d="M30.5994 14.351L30.5997 5.39979L21.6494 5.39965"
      stroke={strokeColor}
      strokeWidth={strokeWeight}
    />
    <path
      d="M5.39893 30.6006L15.5787 20.4212"
      stroke={strokeColor}
      strokeWidth={strokeWeight}
    />
    <path
      d="M5.39914 21.6536L5.39888 30.601L14.3454 30.6011"
      stroke={strokeColor}
      strokeWidth={strokeWeight}
    />
  </svg>
)

export const Chevron: React.FC<IconProps & { thin?: boolean }> = ({
  strokeColor = colors.dark,
  thin,
  ...rest
}) => (
  <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" {...rest}>
    <title>Chevron Icon</title>
    <path
      d="M8 14l4-4-4-4"
      stroke={rest.stroke || strokeColor}
      strokeWidth={thin ? 1 : rest.strokeWidth || 1.5}
    />
  </svg>
)

export const Youtube: React.FC<IconProps> = ({
  strokeColor = colors.white,
  ...rest
}) => (
  <svg
    width="25"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>Youtube Icon</title>
    <path
      d="M23.077 7.43c0-1.67-1.333-3.202-2.933-3.342a53.62 53.62 0 00-14.93 0A3.15 3.15 0 003.12 5.161a3.427 3.427 0 00-.84 2.27c-.4 2.924-.4 5.988 0 8.912 0 1.671 1.333 3.203 2.932 3.343 4.933.696 9.999.696 14.931 0 1.6-.279 2.8-1.672 2.933-3.343.4-2.924.4-5.988 0-8.912zm-13.065 8.635V7.709l6.666 4.178-6.666 4.178z"
      fill={rest.fill || strokeColor}
    />
  </svg>
)

export const ArrowLeft: React.FC<
  IconProps & {
    svgWidth?: string
    svgHeight?: string
  }
> = ({ svgWidth = "23", svgHeight = "42", ...rest }) => (
  <svg
    viewBox="0 0 23 42"
    width={svgWidth}
    height={svgHeight}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M22 41L2 21 22 1" stroke={rest.stroke || "#FFF"} strokeWidth="2" />
  </svg>
)

export const ArrowRight: React.FC<
  IconProps & {
    svgWidth?: string
    svgHeight?: string
  }
> = ({ svgWidth = "23", svgHeight = "42", ...rest }) => (
  <svg
    viewBox="0 0 23 42"
    width={svgWidth}
    height={svgHeight}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M1 1l20 20L1 41" stroke={rest.stroke || "#FFF"} strokeWidth="2" />
  </svg>
)

export const ArrowUP: React.FC<
  IconProps & {
    svgWidth?: string
    svgHeight?: string
  }
> = ({ svgWidth = "33", svgHeight = "20", ...rest }) => (
  <svg
    width={svgWidth}
    height={svgHeight}
    viewBox="0 0 33 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 18L16.5 4L30.5 18" stroke="#63666A" strokeWidth="5" />
  </svg>
)

export const ArrowDown: React.FC<
  IconProps & {
    svgWidth?: string
    svgHeight?: string
  }
> = ({ svgWidth = "33", svgHeight = "20", ...rest }) => (
  <svg
    width={svgWidth}
    height={svgHeight}
    viewBox="0 0 33 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M30.5 2L16.5 16L2.5 2" stroke="#63666A" strokeWidth="5" />
  </svg>
)

export const PlayButton: React.FC<IconProps> = ({
  strokeColor = "#FFF",
  ...rest
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_37:935)">
      <g filter="url(#filter0_f_37:935)">
        <circle cx="25" cy="25" r="20" fill="black" fillOpacity="0.15" />
      </g>
      <path
        d="M25 6.6C35.1 6.6 43.4 14.9 43.4 25C43.4 35.1 35.1 43.4 25 43.4C14.9 43.4 6.6 35.1 6.6 25C6.6 14.9 14.9 6.6 25 6.6ZM25 5C14 5 5 14 5 25C5 36 14 45 25 45C36 45 45 36 45 25C45 14 36 5 25 5Z"
        fill="white"
      />
      <path
        d="M33.9996 26C34.8996 25.4 34.8996 24.5 33.9996 24L22.2996 17C21.3996 16.4 20.5996 16.9 20.5996 18V32C20.5996 33.1 21.3996 33.5 22.2996 33L33.9996 26Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_37:935"
        x="-3"
        y="-3"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4"
          result="effect1_foregroundBlur_37:935"
        />
      </filter>
      <clipPath id="clip0_37:935">
        <rect width="50" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

// TODO: Convert above icons to viewBox
// Please use viewBox moving forward
export const AltShoppingCart: React.FC<IconProps> = ({
  strokeColor = "#000",
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.026 3.472h.98a1 1 0 01.975.776l1.59 6.941a1 1 0 00.974.777h7.408"
        stroke={strokeColor}
      />
      <path
        d="M4.305 6.178h9.275a1 1 0 01.975 1.222l-.336 1.476a1 1 0 01-.975.778h-8.01"
        stroke={strokeColor}
      />
      <circle cx="5.772" cy="14.073" fill={strokeColor} r=".762" />
      <circle cx="13.055" cy="14.073" fill={strokeColor} r=".762" />
    </svg>
  </IconWrapper>
)

export const CartCheckmark: React.FC<IconProps> = ({
  strokeColor = colors.success,
  ...rest
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx="12.5"
      cy="12.5"
      r="8.75"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M8.563 12.5l2.624 2.625 5.25-5.25"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
)

export const Close: React.FC<IconProps> = ({
  strokeColor = colors.dark,
  strokeWidth = "1.5",
  opacity = ".5",
  ...rest
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>Close Icon</title>
    <g
      stroke={strokeColor}
      strokeMiterlimit="10"
      strokeWidth={strokeWidth}
      opacity={opacity}
    >
      <path d="M1 21.227l20-20M21 21.227l-20-20" />
    </g>
  </svg>
)

export const Filter: React.FC<IconProps> = ({
  strokeColor = "#000",
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={strokeColor}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M5.302 6.5h-3.9M24.802 6.5h-14.3M15.702 13h-14.3M24.802 13h-3.9M7.902 19.5h-6.5M24.802 19.5h-11.7"
      />
      <circle
        cx="7.901"
        cy="6.5"
        r="2.6"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <circle
        cx="18.301"
        cy="13"
        r="2.6"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <circle
        cx="10.502"
        cy="19.5"
        r="2.6"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  </IconWrapper>
)

export const FormCheckmark: React.FC<IconProps> = ({
  strokeColor = "#FFF",
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path stroke={strokeColor} strokeWidth="1.5" d="M5.602 10l3 3 6-6" />
    </svg>
  </IconWrapper>
)

export const Grid: React.FC<IconProps> = ({
  strokeColor = "#000",
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={strokeColor}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M11.236 3.568H3.67v7.566h7.566V3.568zM22.533 3.568h-7.566v7.566h7.566V3.568zM11.236 14.865H3.67v7.566h7.566v-7.566zM22.533 14.865h-7.566v7.566h7.566v-7.566z"
      />
    </svg>
  </IconWrapper>
)

export const List: React.FC<IconProps> = ({
  strokeColor = "#000",
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={strokeColor}
        strokeWidth="1.5"
        d="M12.252 5.4h13.5m-13.5 11.438h13.5m-13.5 4.762h13.5m-13.5-11.482h13.5"
      />
      <path
        fill={strokeColor}
        d="M1.451 4.384h6.75v6.75h-6.75zM1.451 15.859h6.75v6.75h-6.75z"
      />
    </svg>
  </IconWrapper>
)

export const Logo: React.FC<IconProps> = ({
  strokeColor = colors.brand,
  ...rest
}) => (
  <IconWrapper {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 121 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.342 33.227C4.557 20.796 29.874 6.817 62.888 1.999 72.622.578 81.93.112 90.278.482c-9.621-.888-20.875-.575-32.741 1.152C24.52 6.454-.796 20.436.987 32.864c1.26 8.76 15.66 14.415 35.614 15.294-17.136-1.585-29.119-6.976-30.26-14.931z"
        fill={strokeColor}
      />
      <path
        d="M115.457 15.061c1.781 12.428-23.54 26.406-56.552 31.225-9.728 1.423-19.044 1.886-27.39 1.52 9.624.89 20.877.576 32.746-1.154 33.013-4.821 58.331-18.801 56.546-31.229C119.55 6.659 105.151 1.01 85.197.125c17.135 1.586 29.115 6.978 30.26 14.936z"
        fill={strokeColor}
      />
      <path
        d="M62.525 11.495s2.535.248 2.52.248c2.503.248 5.305.239 7.299.07 0 0 5.64-.696 8.914-.66 0 0 3.844-.165 2.458 2.925l-1.17 1.97 5.108-.007 2.716-4.743s1.503-2.938-1.717-3.438c0 0-.394-.099-2.481-.144l-26.583.035s-6.226-.13-9.25 2.846c0 0-.656.7-1.961 2.354l-2.089 3.06 5.135.007s.8-1.807 2.58-3.06c0 .006 3.163-2.354 8.52-1.463zM79.966 17.236c.056.026.01.076.01.076l-12.719 5.681 2.67-.023s6.362-.521 4.817 3.168l-2.93 5.19v.001l-10.194-.026 2.14-3.67c.792-1.174-.477-1.327-.477-1.327h-6.096c-1.508 0-1.902.86-1.902.86l-2.548 4.238-7.807-.078 8.111-13.982.045-.001 8.164-.026-3.484 5.842 11.288-5.932 10.912.01h.004-.004zM32.586 20.833l16.32.037 2.114-3.531-21.207-.026s-3.621-.35-5.434 2.686l-1.802 3.2s-1.625 2.247 1.247 2.263l13.375-.003s1.727-.13 1.085 1.223c0 0-.176.775-1.82.628l-16.24-.023-2.267 3.95 19.625-.002s5.326.378 6.684-2.22l2.256-3.923s1.52-2.418-1.025-2.434l-14.104.027c-1.04-.025-.41-1.053-.41-1.053.416-.914 1.603-.8 1.603-.8zM73.802 31.328l.002-.001h-.002v.001zm27.477-14.047l-19.452-.046v.004l-8.026 14.086 14.747-.14h5.131c4.985.063 6.433-3.139 6.433-3.139l1.225-2.175c1.165-1.994-1.58-1.994-1.58-1.994 3.103-.271 3.907-2.032 3.907-2.032l.793-1.482c1.809-3.415-3.178-3.082-3.178-3.082zm-9.037 9.135c-.205.493-.823.884-1.376.88l-7.275.014 1.084-1.866 6.92.015c.554.003.859.473.647.957zm2.856-4.622c-.208.487-.838.827-1.417.9l-7.428-.006 1.025-1.836h7.203c.542.058.82.455.617.942zM48.503 34.548c.296.199.39.491.283.872a1.376 1.376 0 01-.105.273h-1.5l.09-.176a.1.1 0 00.018-.037l.011-.043c.035-.13.003-.23-.098-.306-.1-.072-.251-.11-.448-.11h-.039c-.248 0-.46.046-.634.138a.825.825 0 00-.37.358l-.47.97c-.007.004-.014.017-.017.033l-.01.037a.272.272 0 00.103.306c.1.082.248.124.44.124h.108c.493 0 .828-.17 1.001-.5l.083-.164h1.426c-.226.453-.59.806-1.088 1.063-.5.255-1.086.384-1.76.384h-.213a3.3 3.3 0 01-1.053-.148c-.293-.102-.503-.247-.636-.435-.13-.187-.158-.413-.088-.675.01-.037.042-.114.096-.236.055-.12.143-.298.255-.536.144-.297.369-.557.681-.787a3.555 3.555 0 011.09-.523 4.535 4.535 0 011.32-.189h.212c.58 0 1.017.102 1.312.307zM55.425 37.721h-1.65l-.003-.61h-1.65l-.608.61h-1.522l3.454-3.429h1.988l-.008 3.43zm-1.6-2.373l-.97 1.04h.925l.082-1.04h-.037zM63.181 34.465c.308.15.418.373.327.667a.917.917 0 01-.098.217h-1.46l.036-.092c.027-.073-.002-.133-.085-.183a.857.857 0 00-.4-.076c-.223 0-.4.024-.53.068-.13.044-.202.097-.225.17-.022.076.026.132.148.172.121.04.334.08.63.133.326.047.595.094.802.152.208.055.374.142.5.258.126.118.16.273.099.465-.119.383-.413.703-.888.961-.475.262-1.177.395-2.104.395-.574 0-1.027-.081-1.357-.236-.33-.16-.45-.394-.359-.697.02-.066.063-.16.133-.287h1.47a.294.294 0 00-.064.111c-.027.09 0 .164.085.222.085.053.24.082.468.082.51 0 .79-.079.84-.24.022-.073-.026-.128-.145-.164a4.307 4.307 0 00-.588-.12 6.307 6.307 0 01-.802-.16c-.21-.057-.38-.15-.511-.272-.128-.128-.162-.294-.098-.502.123-.41.444-.722.966-.94.519-.219 1.15-.327 1.893-.327.569-.001 1.008.073 1.317.223zM70.347 35.085h-2.2l-.273.5h2.111l-.405.762h-2.108l-.298.555h2.165l-.264.82H65.18l1.82-3.43h3.924l-.577.793zM77.278 34.465c.303.15.405.373.306.667a1.07 1.07 0 01-.103.217h-1.46l.038-.092c.03-.073.005-.133-.078-.183-.084-.047-.215-.076-.398-.076-.222 0-.4.024-.531.068-.132.044-.207.097-.231.17-.026.076.022.132.142.172.124.04.332.08.63.133.325.047.59.094.794.152.209.055.374.142.495.258.122.118.15.273.085.465-.13.383-.434.703-.916.961-.48.262-1.185.395-2.114.395-.575 0-1.025-.081-1.35-.236-.329-.16-.441-.394-.34-.697.022-.066.067-.16.142-.287h1.47a.281.281 0 00-.068.111c-.03.09-.005.164.077.222.085.053.238.082.468.082.509 0 .79-.079.844-.24.024-.073-.021-.128-.14-.164a4.148 4.148 0 00-.583-.12 6.18 6.18 0 01-.796-.16 1.162 1.162 0 01-.503-.272c-.126-.128-.154-.294-.085-.502.135-.41.465-.722.99-.94.527-.219 1.162-.327 1.906-.327.567-.001 1.003.073 1.309.223z"
        fill={strokeColor}
      />
    </svg>
  </IconWrapper>
)

export const MagnifyingGlass: React.FC<IconProps> = ({
  width,
  height,
  strokeColor = colors.dark,
  ...rest
}) => (
  <svg
    width={width || "100%"}
    height={height || "100%"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      stroke={strokeColor}
      strokeWidth="1.5"
      d="M22.816 13.209a9.605 9.605 0 11-19.21 0 9.605 9.605 0 0119.21 0zM20.379 20.378l4.78 4.78"
    />
  </svg>
)

export const Success: React.FC<IconProps> = ({ ...rest }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 130 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx="65"
      cy="65"
      r="45.5"
      stroke="#00CB51"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      stroke="#00CB51"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M44.523 65l13.65 13.65 27.3-27.3"
    />
  </svg>
)
